import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vxe-table/lib/index.css' // 引入样式
import '@/css/reset.less'
import '@/utils/vxetable'
import axios from 'axios'

// 将axios添加到Vue原型上
Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
